import Recat, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Select, message, Spin, InputNumber } from 'antd'
import { SGeneralForms } from 'shj-components'
import { httpDictServTenant, findQuotationTypes, paymentApplySelectMainContractNo} from "@/services/fmsServices";
import dayjs from 'dayjs'
export const AddOrEditForm = Recat.forwardRef((props: any, ref) => {
  const { editData, readOnly, orderId } = props
  const formRef: any = useRef()
  const [spinning, setSpinning] = useState(false)
  const [selectMainContractNoLists, setSelectMainContractNoLists] = useState<any>([])
  const reqMeg = '不能为空'
  useEffect(() => {
    initFn()
  }, [])
  useImperativeHandle(ref, () => ({
    getValue: () => formRef.current?.onFormRef()?.getFieldsValue(),
    validateFields: () => formRef.current?.onFormRef()?.validateFields(),
  }));
  const initFn = async () => {
    if (editData) {
      setSpinning(true)
      editData.receivableDate = editData.receivableDate ? dayjs(editData.receivableDate) : undefined
      editData.createdTime = editData.createdTime ? dayjs(editData.createdTime) : undefined
      formRef.current?.onFormRef()?.setFieldsValue({...editData})
      setSpinning(false)
    }
  }
  const getOptions = async () => {
    let paymentTypeList = await httpDictServTenant({ parentKey: 'receiptType',enabled: 1 })
    let contractTypeList = await findQuotationTypes()
    let selectMainContractNoList = await paymentApplySelectMainContractNo({orderId})
    setSelectMainContractNoLists(selectMainContractNoList)
    return Promise.resolve({
      paymentTypeList,
      contractTypeList,
      selectMainContractNoList
    })
  }
  const setAmount = (e) =>{
    formRef.current?.onFormRef()?.setFieldsValue({
      verifiedAmount: 0,
      unverifiedAmount: 0, //需求就是这么奇怪
      // unverifiedAmount: e
    })
  }
  return (
    <Spin spinning={spinning}>
      <SGeneralForms
        ref={formRef}
        httpOptionsFn={getOptions}
        isDetail={readOnly}
        layout="vertical"
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '应收单号',
                name: 'billNo',
                spanCol: 8,
                required: true,
                isHideItem: !editData?.id,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '收款类型',
                name: 'receiptType',
                spanCol: 8,
                type: 'select',
                data: 'paymentTypeList',
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  fieldNames: { value: 'priKey', label: 'name' },
                },
              },
              {
                label: '核销状态',
                name: 'verifyStateName',
                spanCol: 8,
                required: true,
                rules: [{ required: true, message: reqMeg }],
                isHideItem: !editData?.id,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '应收金额',
                name: 'receivableAmount',
                spanCol: 8,
                required: true,
                rules: [{ required: true, message: reqMeg }],
                children: (
                  !readOnly?<InputNumber placeholder='请输入应收金额' onChange={setAmount}/>:<span>{editData?.receivableAmount}</span>
                )
              },
              {
                label: '支付状态',
                name: 'payStateName',
                spanCol: 8,
                required: true,
                rules: [{ required: true, message: reqMeg }],
                isHideItem: !editData?.id,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '已核销金额',
                name: 'verifiedAmount',
                spanCol: 8,
                required: true,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '未核销金额',
                name: 'unverifiedAmount',
                required: true,
                spanCol: 8,
                rules: [{ required: true, message: reqMeg }],
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '应收日期',
                name: 'receivableDate',
                required: true,
                type: 'dateTime',
                spanCol: 8,
                rules: [{ required: true, message: reqMeg }],
              },
              {
                label: '合同号',
                name: 'contractNo',
                spanCol: 8,
                type: 'select',
                data: 'selectMainContractNoList',
                isHideItem: !editData?.id,
                comConfig: {
                  fieldNames: { value: 'contractNo', label: 'contractNo' },
                  onChange: (value) => {
                    const selectedContract = selectMainContractNoLists.find(
                      (contract) => contract.contractNo === value
                    );
                    formRef.current?.onFormRef()?.setFieldsValue({
                      contractType: selectedContract?.budgetType || '',
                    });
                  }
                },
              },
              {
                label: '合同类型',
                name: 'contractType',
                spanCol: 8,
                type: 'select',
                data: 'contractTypeList',
                isHideItem: !editData?.id,
                comConfig: {
                  fieldNames: { value: 'code', label: 'desc' },
                  disabled: true
                },
              },
              {
                label: '创建时间',
                name: 'createdTime',
                type: 'dateTime',
                spanCol: 8,
                isHideItem: !editData?.id,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '备注',
                type: 'textarea',
                name: 'remark',
                comConfig: {
                  maxLength: 50,
                },
                spanCol: 24,
              },
            ],
          },
        ]}
      />
    </Spin>
  )
})
